import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_OPTION_PRICE } from "../../../Schema/OptionPrice";

const useDeleteOptionPrice = ({ handleClose, setRefetch, id }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteOptionPrice] = useMutation(DELETE_OPTION_PRICE, {
    onCompleted: ({ deleteOptionPrice }) => {
      setLoading(false);
      if (deleteOptionPrice?.isSuccess === true) {
        setAlert(true, "success", deleteOptionPrice?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteOptionPrice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteOptionPrice({
      variables: {
        id: id,
      },
    });
  };

  return { deleteOptionPrice, loading, setLoading, handleDelete };
};

export default useDeleteOptionPrice;
